<template>
  <div class="card-header">
    <h5>Provide Feedback</h5>
  </div>
  <div class="card-body pt-0 mt-0">
    <p class="text-muted mb-4">Something not as you expect? Let us know.</p>
    <textarea
      id="feedback-text"
      v-model="feedbackValue"
      style="width: 100%; padding: 10px; border-color: #7b809a;"
      class="border-radius-lg text-muted muted mb-4"
      rows="8"
      name="name"
      placeholder="Enter your feedback here..."
      maxlength="2000"
    ></textarea>
    <div class="d-flex justify-content-between align-items-center mb-4">
      <small class="text-muted">{{ feedbackValue.length }}/2000 characters</small>
      <material-button
        class="mb-0"
        color="shareguard"
        variant="fill"
        size="sm"
        :disabled="!feedbackValue.trim() || feedbackValue.length > 2000"
        @click="submitFeedback"
        >Submit
      </material-button>
    </div>
  </div>
</template>

<script>
import MaterialButton from "@/components/ui/MaterialButton.vue";
import { submitFeedback } from "@/services/feedback.service";

export default {
  name: "FeedbackForm",
  components: {
    MaterialButton
  },
  data() {
    return {
      feedbackValue: ''
    };
  },
  methods: {
    submitFeedback() {
      if (!this.feedbackValue.trim()) {
        this.$store.dispatch("snackbar/showSnackbar", { 
          title: "Please enter your feedback", 
          color: "warning" 
        }, { root: true });
        return;
      }

      if (this.feedbackValue.length > 2000) {
        this.$store.dispatch("snackbar/showSnackbar", { 
          title: "Feedback exceeds maximum length of 2000 characters", 
          color: "warning" 
        }, { root: true });
        return;
      }

      this.$store.dispatch("analytics/trackEvent", {
        event: 'feedback_submitted',
        properties: {
          feedback: this.feedbackValue
        }
      }, { root: true });

      submitFeedback(this.feedbackValue)
        .then(() => {
          this.$store.dispatch("snackbar/showSnackbar", { 
            title: "Thank you for your feedback!", 
            color: "success" 
          }, { root: true });
          this.feedbackValue = '';
        })
        .catch((error) => {
          this.$store.dispatch("snackbar/showSnackbar", { 
            title: "Error submitting feedback", 
            color: "danger" 
          }, { root: true });
          this.$store.dispatch("analytics/trackEvent", {
            event: 'feedback_submission_failed',
            properties: {
              error: error.message
            }
          }, { root: true });
        });
    }
  }
};
</script> 